// Auto-generado desde "Cortinas de Enrollar.xlsx".
// Productos que pertenecen a la categoria "Cortinas de Enrollar" (van con el operario, junto a perfiles).
export const CORTINAS_ENROLLAR = new Set(["617111171", "617111353", "617111374", "617111375", "617111416", "617111417", "617111424", "617111582", "617116078", "617116080", "617311001", "617311067", "617313034", "617314008", "657313033", "671112863", "671112864", "671113603", "671113604", "671118663", "671118664", "671153433", "671153434", "671153453", "671153454", "671311055", "673120483", "673120484", "673330333", "673330334", "673330353", "673330354", "681054005", "70020032", "70020034", "70040254", "70060021"]);

// Parte A (perfiles/cortinas). Los KITS van en su propia parte (K), no acá.
export const CAT_OPERARIO = ["PERFIL ALUMINIO", "PERFILES ALUMINIO", "CORTINAS DE ENROLLAR"];

// Categoría efectiva de un producto (aplica el override de cortinas por sobre el catálogo).
export function categoriaEfectiva(codUru, doc) {
  if (CORTINAS_ENROLLAR.has(String(codUru))) return "CORTINAS DE ENROLLAR";
  const cat = String(doc?.categoria || "").toUpperCase().trim();
  const padre = String(doc?.padre || "").toUpperCase().trim();
  return (cat && cat !== "SIN_CATEGORIA") ? cat : padre;
}

// ¿El producto lo prepara el operario (Parte A: perfiles/cortinas)?
export function esParteOperario(codUru, doc) {
  return CAT_OPERARIO.includes(categoriaEfectiva(codUru, doc));
}

// Detecta si un producto es un KIT (por flag del catálogo o por el nombre "Kit ...").
export function esKitProducto(codUru, doc, item) {
  if (doc?.esKitFinnegans === true || doc?.esKit === true || item?.esKit === true) return true;
  const nombre = String(doc?.customerNo || doc?.descripcion || item?.descripcion || item?.desc || item?.nombre || "").toLowerCase();
  return /\bkit\b/.test(nombre);
}

// Parte a la que pertenece un producto. Se clasifica por substring de la categoría
// efectiva (robusto a variantes de nombre en el catálogo):
//   A   = Perfiles de aluminio + Cortinas
//   ACC = Accesorios de aluminio
//   PVC = PVC (accesorios PVC + perfiles PVC)
//   VID = Vidrios
//   K   = Kits
//   B   = Resto / otros
export function parteDeProducto(codUru, doc, item) {
  if (esKitProducto(codUru, doc, item)) return "K";
  const cat = categoriaEfectiva(codUru, doc); // ya viene en MAYÚSCULAS
  if (cat.includes("VIDRIO")) return "VID";
  if (cat.includes("PVC")) return "PVC"; // incluye "ACCESORIO PVC" y "PERFILES PVC"
  if (cat.includes("ACCESORIO") && cat.includes("ALUMINIO")) return "ACC";
  if (esParteOperario(codUru, doc)) return "A"; // perfiles aluminio + cortinas
  return "B";
}

// Etiquetas legibles de cada parte.
export const PARTE_LABEL = {
  A: "Perfiles / Cortinas",
  ACC: "Accesorios de Aluminio",
  PVC: "PVC",
  VID: "Vidrios",
  K: "Kits",
  B: "Otros",
};

// Orden en que se muestran las partes en la UI.
export const PARTE_ORDER = ["A", "ACC", "PVC", "VID", "K", "B"];

// Reglas de quién puede ser responsable de cada parte:
//   elegibles: null = cualquiera; array de nombres = solo esos (match por nombre).
//   preferido: nombre preseleccionado por defecto (o null).
export const REGLAS_PARTE = {
  A:   { elegibles: null, preferido: null },
  ACC: { elegibles: ["Hansel", "Francisco"], preferido: "Hansel" },
  PVC: { elegibles: ["Hansel", "Francisco", "Luis"], preferido: "Luis" },
  VID: { elegibles: ["Hansel", "Francisco", "Luis"], preferido: "Hansel" },
  K:   { elegibles: null, preferido: null },
  B:   { elegibles: null, preferido: null },
};

function nombreCoincide(nombreOperario, target) {
  return String(nombreOperario || "").toLowerCase().includes(String(target || "").toLowerCase());
}

// Operarios elegibles para una parte (según REGLAS_PARTE, match por nombre).
export function operariosElegiblesParte(parte, operarios) {
  const regla = REGLAS_PARTE[parte];
  if (!regla || !regla.elegibles) return operarios || [];
  return (operarios || []).filter((op) =>
    regla.elegibles.some((nom) => nombreCoincide(op.nombre || op.displayName, nom))
  );
}

// Operario preseleccionado por defecto para una parte (o null).
export function operarioPreferidoParte(parte, operarios) {
  const regla = REGLAS_PARTE[parte];
  if (!regla || !regla.preferido) return null;
  return (operarios || []).find((op) => nombreCoincide(op.nombre || op.displayName, regla.preferido)) || null;
}
